import { Button as MantineButton } from '@mantine/core';
import { ReactNode } from 'react';

type ButtonProps = {
  variant?: 'primary';
  size?: 'md' | 'sm';
  children?: ReactNode | string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  name?: string;
  disabled?: boolean;
};

export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  type,
  name,
  disabled,
}: ButtonProps) {
  return (
    <MantineButton variant={variant} size={size} type={type} name={name} disabled={disabled}>
      {children}
    </MantineButton>
  );
}
